import { ChangeEvent, useEffect, useState } from "react";

interface RoiCalculatorProps {
    inquiry:number
}

const RoiCalculator = ({inquiry}:RoiCalculatorProps) => {

    const [formData, setFormData] = useState({
        henv: inquiry,
        salg: 50,
        verdi: 0,
        pris: 0
    });

    const [roi, setRoi] = useState<string>("0");

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: parseFloat(value) || 0
        }));
    };

    const handleReset = () => {
        setFormData({henv: inquiry, salg: 50, verdi: 0, pris: 0})
    }

    const handleClear = () => {
        setFormData({henv: 0, salg: 0, verdi: 0, pris: 0})
    }

    useEffect(() => {
        const { henv, salg, verdi, pris } = formData;
        const calculatedRoi = (henv * (salg / 100) * verdi) - pris;
        setRoi(calculatedRoi.toFixed(0)); 
    }, [formData]);

    return (
        <div className="card mb-4 cc-roi-calc">
            <div className="card-header">
                <h2 className="fs-5">Avkastning på annonsering hos 1881 – Prøv vår kalkulator!</h2>
            </div>
            <div className="card-body">
                <div className="cc-details-summary mb-3"> 
                    <details>   
                        <summary className="cc-clr-link">Om kalkulatoren</summary>
                        <p className="mt-2 mb-4 text-muted"><small>Denne kalkulatoren er ment som et hjelpemiddel for å regne ut potensiell gevinst på et kjøp av annonsering på 1881.no. 
                        Våre undersøkelser viser at det ikke skal mange salgene til før det er positiv avkastning. 
                        Dra litt i «spakene» og legg inn dine verdier.</small></p>
                    </details> 
                </div>    
                <form id="roiForm" action="#">
                    <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="pris">Pris for 1881-annonsering i 12 måneder</label>
                        </div>
                        <div className="col-sm-6">
                            <input id="pris" type="number" value={formData.pris} onChange={handleChange} className="form-control cc-mw-180 d-inline-block text-end" />
                        </div>
                    </div>
                    <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="henv">Antall henvendelser fra 1881 i perioden</label>
                            <span className="cc-help ms-1" data-bs-toggle="tooltip" data-bs-title="Totalt antall telefoner, klikk til hjemmeside og e-poster fra 1881 til din bedrift."><i className="bi bi-question-circle"></i></span>
                        </div>
                        <div className="col-sm-6">
                            <input id="henv" type="number" value={formData.henv} onChange={handleChange} className="form-control text-end cc-mw-180 d-inline-block" />
                        </div>
                    </div>
                    <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="salg">Andel av henvendelser som leder til salg</label>
                            <span className="cc-help ms-1" data-bs-toggle="tooltip" data-bs-title="Antatt andel som vanligvis leder til salg.">
                                <i className="bi bi-question-circle"></i>
                            </span>
                        </div>
                        <div className="col-sm-6">
                            <div className="cc-mw-180 d-inline-block">
                                <input id="salg" type="range" value={formData.salg} min="0" max="100" className="" onChange={handleChange} />
                                <output id="salgOutput">&nbsp;{formData.salg}</output>
                                &nbsp;%&nbsp;
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="verdi">Ca. verdi pr. henvendelse</label>
                            <span className="cc-help ms-1" data-bs-toggle="tooltip" data-bs-title="Gjennomsnittsverdi pr. salg. "><i className="bi bi-question-circle"></i></span>
                        </div>
                        <div className="col-sm-6">
                            <input id="verdi" type="number" value={formData.verdi} onChange={handleChange} className="form-control text-end cc-mw-180 d-inline-block" />
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-sm-6">
                            <label htmlFor="roi" className="fw-medium">Inntjening ved å annonsere</label>
                            <span className="cc-help ms-1" data-bs-toggle="tooltip" data-bs-title="Utregnet fra innholdet i kalkulatoren. Andre kostnader hensyntas ikke."><i className="bi bi-question-circle"></i></span>
                        </div>
                        <div className="col-sm-6">
                            <input id="roi" type="number" value={roi}  className="form-control text-end cc-mw-180 d-inline-block border border-2 border-primary" readOnly />
                        </div>
                    </div>
                    <div className="mt-4 d-md-flex align-items-center gap-2">
                        <button type="button" className="btn btn-outline-primary" onClick={handleClear}>Nullstill</button>
                        <button type="reset" className="btn btn-link p-0 text-decoration-none" onClick={handleReset}>Tilbakestill</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default RoiCalculator;